import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async thunks
export const fetchEncodingProfiles = createAsyncThunk(
  'encodingProfiles/fetchAll',
  async () => {
    const response = await api.get('/api/encoding-profiles/');
    return response.data;
  }
);

export const fetchEncodingProfile = createAsyncThunk(
  'encodingProfiles/fetchOne',
  async (id) => {
    const response = await api.get(`/api/encoding-profiles/${id}`);
    return response.data;
  }
);

export const createEncodingProfile = createAsyncThunk(
  'encodingProfiles/create',
  async (profileData) => {
    const response = await api.post('/api/encoding-profiles/', profileData);
    return response.data;
  }
);

export const updateEncodingProfile = createAsyncThunk(
  'encodingProfiles/update',
  async ({ id, ...profileData }) => {
    const response = await api.put(`/api/encoding-profiles/${id}`, profileData);
    return response.data;
  }
);

export const deleteEncodingProfile = createAsyncThunk(
  'encodingProfiles/delete',
  async (id) => {
    await api.delete(`/api/encoding-profiles/${id}`);
    return id;
  }
);

export const setDefaultEncodingProfile = createAsyncThunk(
  'encodingProfiles/setDefault',
  async (id) => {
    await api.post(`/api/encoding-profiles/${id}/set-default`);
    return id;
  }
);

// Slice
const encodingProfilesSlice = createSlice({
  name: 'encodingProfiles',
  initialState: {
    profiles: [],
    currentProfile: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all profiles
      .addCase(fetchEncodingProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEncodingProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(fetchEncodingProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch one profile
      .addCase(fetchEncodingProfile.fulfilled, (state, action) => {
        state.currentProfile = action.payload;
      })
      // Create profile
      .addCase(createEncodingProfile.fulfilled, (state, action) => {
        state.profiles.push(action.payload);
      })
      // Update profile
      .addCase(updateEncodingProfile.fulfilled, (state, action) => {
        const index = state.profiles.findIndex(p => p.id === action.payload.id);
        if (index !== -1) {
          state.profiles[index] = action.payload;
        }
      })
      // Delete profile
      .addCase(deleteEncodingProfile.fulfilled, (state, action) => {
        state.profiles = state.profiles.filter(p => p.id !== action.payload);
      })
      // Set default
      .addCase(setDefaultEncodingProfile.fulfilled, (state, action) => {
        state.profiles.forEach(profile => {
          profile.is_default = profile.id === action.payload;
        });
      });
  },
});

export const { clearError } = encodingProfilesSlice.actions;
export default encodingProfilesSlice.reducer;